export default {
    "loading": "Loading",
    "notLong": "This shouldn't take long!",
    "wait": "Please wait",
    "providedBy": "Information Security Awareness Provided by",
    "exit": "Exit",
    "replay": "Replay",
    "completedTutorial": "You have completed this tutorial",
    "congrats": "Congratulations!",
    "soundOn": "Please ensure your sound is turned on,<br />or turn on subtitles using the <span style=\"background: #333;display: inline-block;\"><img src=\"../../../dist/icons/subtitles.svg\" alt=\"subtitles\" style=\"display: inline-block;height: 1em;width: 1em;\" /></span> button in the top right of the screen",
    "start": "Start",
    "confirm": "Confirm",
    "correct": "Correct",
    "incorrect": "Incorrect",
    "ok": "OK",
    "cancel": "Cancel",
    "explanation": "Explanation",
    "questionResults": "Question Results",
    "thankyou": "Thank you for your time",
    "approvalInfo": "As a member of the feedback group, we need your approval to release this to the rest of your organisation!",
    "iapprove": "I approve this tutorial",
    "enterComments": "Enter any comments here",
    "sendExit": "Send & Exit",
    "yourChoices": "Your choices",
    "yourAnswer": "Your answer"
}